<template>
  <div>
    <div v-if="loading" class="loading-md bg">
        <i class="fas fa-spinner"></i>
        <div v-if="!$helpers.isEmpty(loadingText)" class="loading-text">
                {{ loadingText }}
        </div>
    </div>


  </div>

</template>

<script>
import { mapState, mapGetters } from 'vuex';
export default {
  name: 'employeeworkbalancecreation',
  data () {
    return {

      // loading: false,
      // loadingText: null,

    }
  },
  props: {
    loading: {
      default: () => false,
      type: Boolean,
    },
    loadingText: {
      default: () => null,
      type: String,
    },
  },
  created: function () {


        this.$helpers.GetStoreSettings();

  },
  beforeDestroy() {


  },
  components: {
  },
  computed: {
        ...mapGetters(['storeId', 'storeSettings', 'allowedContractMap', 'collectiveContractMap', 'accountingPeriodSettingsMap', 'contractExitSettingMap', 'uiDataMap']),
        exitReasonReverseIdMap() {
            let map = {};
            this.uiDataMap.exitReasons.forEach(item => {
                if(item.idL != null){
                    map[""+item.idL] = item.id;
                }
            });
            return map;
        },


  },
  watch: {



  },
  // methods that implement data logic.
  methods: {
    recalculateFromTo(fromDate, toDate, employeeIds, forced = false, erasePayment = false, silent = false){
        return this.recursiveRecalcStep(fromDate, toDate, employeeIds, forced, erasePayment, silent);
    },
    recalculatePastInvalid(monthDate, employeeIds, alwaysRecalcDate = null, erasePayment = false, silent = false, workTimeMode = 1){
        let view = this;

        return view.loadEarliestInvalidMonthEmployeeWorkBalanceDate({ids: employeeIds})
        .then(date => {
            
            if(date != null && date <= monthDate){
                console.log("EWB DATE: "+date.format());
                let target = monthDate;
                if(monthDate.diff(date, 'months') > 12){ //max recalc 12 months
                    console.log("last valid ewb back longer than 12 months!")
                    target = date.clone().add(12, 'months');
                }
                return view.recursiveRecalcStep(date, target, employeeIds, false, erasePayment, silent, workTimeMode);
            } else {
                if(alwaysRecalcDate != null){
                    return view.doMonthYearRecalculation(alwaysRecalcDate.month(), alwaysRecalcDate.year(), employeeIds, true, erasePayment, silent, workTimeMode)
                    .then(result => {
                        if(result == true){
                           return new Promise((accept, resolve) => {
                                accept(true);
                            })
                        } else {
                            return new Promise((accept, resolve) => {
                                accept(false);
                            })
                        }
                    })
                } else {
                    return new Promise((accept, resolve) => {
                        accept(false);
                    })
                }

            }
        })
    },
    recursiveRecalcStep(current, target, employeeIds, forced = false, erasePayment = false, silent = false, workTimeMode = 1){
        let view = this;
        if(current > target){
            return new Promise((accept, resolve) => {
                accept(true);
            })
        } else {
            return view.doMonthYearRecalculation(current.month(), current.year(), employeeIds, forced, erasePayment, silent, workTimeMode)
            .then(result => {
                if(result == true){
                    return view.delay(500).then(res => {
                        return view.recursiveRecalcStep(current.add(1, 'months'), target, employeeIds, forced, erasePayment, silent, workTimeMode)
                    });
                } else {
                    return new Promise((accept, resolve) => {
                        accept(false);
                    })
                }
            })
        }
    },
    delay(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    },
    doMonthYearRecalculation(month, year, employeeIds = null, forced = false, erasePayment = false, silent = false, workTimeMode = 1){
        console.log("Recalculating EWB: "+(month)+" "+year)
        let view = this;
        let monthDate = this.$helpers.getMomentFromValuesUTC(year, month, 1);
        let usageStartDate = this.$helpers.getMomentFromStringUTC(this.storeSettings.usageStartDate);
        let usdMonth = usageStartDate.month();
        let usdYear = usageStartDate.year();
        let curMonth = monthDate.month();
        let curYear = monthDate.year();
        //let preUsageStartDateMonth = (usdYear == curYear && curMonth == usdMonth - 1) || (curYear == usdYear - 1 && curMonth == 11 && usdMonth == 0);



        let employeeMap = {};
        let validEmployeeMap = {};
        let currentEwbMap = {};
        let spotMap = {};
        let employeePayload = {ids: []};

        return Promise.all([view.loadValidEmployeeWorkBalanceEmployees(monthDate), view.loadActiveAtEmployees(monthDate), view.$helpers.GetAccountingPeriodSettingsMap(), view.$helpers.GetContractExitSettingMap(), view.$helpers.GetUiDataMap()])
        .then(results => {
            validEmployeeMap = results[0];

            Object.values(results[1]).forEach(employee => {
                if(employeeIds != null){
                    if(employeeIds.includes(employee.id)) {
                        employeeMap[employee.id] = employee;
                        employeePayload.ids.push(employee.id);
                    }
                } else {
                   employeeMap[employee.id] = employee;
                   employeePayload.ids.push(employee.id);
                }
            });

            return view.loadCurrentMonthEmployeeWorkBalances(employeePayload, monthDate);
        }).then(map=> {
            currentEwbMap = map;
            return view.$helpers.GetSpotMap();
        }).then(map => {
            spotMap = map;
            let exclEmplIds = [];
            let employeeIds = [];
            let remoteIds = [];
            Object.values(currentEwbMap).forEach((wb) => {
                if((wb.valid && !forced) || !wb.autoCalc || wb.confirmed) exclEmplIds.push(wb.employeeId);
            });
            Object.values(employeeMap).forEach((empl) => {
                if(!exclEmplIds.includes(empl.id) && validEmployeeMap[empl.id] != null){
                    //console.log(empl.firstName+" "+empl.lastName);
                    employeeIds.push(empl.id);
                    if(empl.remoteId != null ){
                        remoteIds.push(empl.remoteId);
                    }
                }
            });
            if(employeeIds.length > 0) {
                console.log("Invalid EWB found")
                employeePayload.ids = employeeIds;

                let currentMonthFrom = monthDate.startOf('month');
                let accountingPeriodSettings = Object.values(this.accountingPeriodSettingsMap).filter(i => i.month == currentMonthFrom.month());
                let contractExitSettings = Object.values(this.contractExitSettingMap).length > 0 ? Object.values(this.contractExitSettingMap) : [];
                let reverseIdMap = this.exitReasonReverseIdMap;

                let currentMonthFromTZ = view.$helpers.getMomentFromValuesTZ(currentMonthFrom.year(), currentMonthFrom.month(), 1);
                let currentMonthTo = currentMonthFrom.clone().add(1, 'month');
                let currentMonthToTZ = currentMonthFromTZ.clone().add(1, 'month');
                

                let actualShiftMap = {};
                let employeeDateActualShiftMap = {};
                let employeeDateActualShiftMarkedMap = {};
                let actualBreakMap = {};
                let actualShiftBreakMap = {};
                let holidayMap = {};
                let employeePlanShiftMap = {};
                let employeePreferenceMap = {};
                let employeeContractMap = {};
                let nextMonthEmployeeContractMap = {};
                let previousMonthWorkBalanceMap =  {};
                let bonusPaymentSettingsMap = {};
                let employeeAvgWorktimeMap = {};

                let ashiftP = view.loadActualShifts(null, monthDate);
                let abreakP = view.loadActualBreaks(null, monthDate);
                let holidayP = view.loadHolidays(monthDate);
                let pshiftP = view.loadEmployeePlanShifts(employeePayload, monthDate);
                let preferenceP = view.loadEmployeePreferences(employeePayload, monthDate);
                let acontractP = view.$helpers.GetAllowedContractMap();
                let ccontractP = view.loadEmployeeContracts(employeePayload, monthDate);
                let ncontractP = view.loadNextMonthEmployeeContracts(employeePayload, monthDate);
                let pewbP = view.loadPreviousMonthEmployeeWorkBalances(employeePayload, monthDate);
                let bpSP = view.loadBonusPaymentSettings(monthDate);
                let avgWtP = view.storeSettings.useAvgWorkTimeForPrefs ? view.$helpers.GetAvgEmployeeWorktimeMapForMonth(remoteIds, monthDate.year(), monthDate.month()+1) : new Promise((accept, reject) => {
                    accept({});
                });

                return Promise.all([ashiftP, abreakP, holidayP, pshiftP, preferenceP, acontractP, ccontractP, ncontractP, pewbP, bpSP, avgWtP])
                .then(results => {
                    actualShiftMap = results[0];
                    //setup employeedateactualshift and marked maps
                    Object.values(actualShiftMap).forEach(entry => {
                        if(!employeeDateActualShiftMap[entry.employeeId]){
                            employeeDateActualShiftMap[entry.employeeId] = {};
                        }
                        if(!employeeDateActualShiftMarkedMap[entry.employeeId]){
                            employeeDateActualShiftMarkedMap[entry.employeeId] = {};
                        }
                        let employeeEntry = employeeDateActualShiftMap[entry.employeeId];
                        let dateKey = view.$helpers.getMomentFromStringTZ(entry.from).format("YYYY-MM-DD");
                        if(!employeeEntry[dateKey]){
                            employeeEntry[dateKey] = [];
                        }
                        employeeEntry[dateKey].push(entry);

                        //if(!entry.endMissing){
                            employeeEntry = employeeDateActualShiftMarkedMap[entry.employeeId];
                            if(entry.planFrom){
                                dateKey = this.$helpers.getMomentFromStringTZ(entry.planFrom).format("YYYY-MM-DD");
                            } else {
                                dateKey = this.$helpers.getMomentFromStringTZ(entry.from).format("YYYY-MM-DD");
                            }
                            employeeEntry[dateKey] = true;
                        //}

                    })

                    actualBreakMap = results[1];
                    Object.values(actualBreakMap).filter(entry => actualShiftMap[entry.shiftId] != null).forEach(entry => {
                        if(!actualShiftBreakMap[entry.shiftId]){
                            actualShiftBreakMap[entry.shiftId] = [];
                        }
                        actualShiftBreakMap[entry.shiftId].push(entry);
                    });
                    holidayMap = results[2];
                    employeePlanShiftMap = results[3];
                    employeePreferenceMap = results[4];
                    employeeContractMap = results[6];
                    nextMonthEmployeeContractMap = results[7];
                    previousMonthWorkBalanceMap = results[8];
                    bonusPaymentSettingsMap = results[9];
                    employeeAvgWorktimeMap = results[10];

                    let multiCreateMap = {};
                    Object.values(employeeMap).filter(employee => employeeIds.includes(employee.id)).forEach(employee => {

                        let balance = view.$helpers.calculateEmployeeWorkBalance(employee, previousMonthWorkBalanceMap, 
                                        employeeContractMap, nextMonthEmployeeContractMap, view.allowedContractMap, view.collectiveContractMap, 
                                        employeePlanShiftMap, employeeDateActualShiftMap, employeeDateActualShiftMarkedMap, holidayMap, actualShiftBreakMap,
                                        employeePreferenceMap, currentEwbMap, spotMap, view.storeSettings, currentMonthFrom, currentMonthTo, currentMonthFromTZ, currentMonthToTZ,
                                        workTimeMode, erasePayment, accountingPeriodSettings, contractExitSettings, false, reverseIdMap, bonusPaymentSettingsMap, employeeAvgWorktimeMap);
                        multiCreateMap[employee.id] = balance;
                    });
                    return view.createMultiEmployeeWorkBalance(false, multiCreateMap, currentMonthFrom);


                }).then(result => {

                    if(!silent)view.$helpers.success(view.$t('global.notifications.updateMessage'), view.$t('workBalance.balances.createOverview', [view.$helpers.getMomentFromValuesTZ(year, month, 1).format("MMMM YYYY")]))
                    return new Promise((accept, reject) =>{
                        accept(true);
                    })
                }).catch(error => {
                    console.log(error);
                    view.$helpers.error(view.$t('global.notifications.error'), view.$t('workBalance.payroll.loadingWorkBalanceError'));
                    return new Promise((accept, reject) =>{
                        accept(false);
                    })
                })
            } else {

                return new Promise((resolve, reject) => {
                    resolve(true);
                });
            }
        }).catch(error => {
            console.log(error);
            view.$helpers.error(view.$t('global.notifications.error'), view.$t('workBalance.payroll.loadingWorkBalanceError'));
            return new Promise((accept, reject) =>{
                accept(false);
            })
        });
    },



    createMultiEmployeeWorkBalance: function(modal, createMap, currentMonthFrom){


        if(Object.values(createMap).length > 0){

            let view = this;
            let url = '/api/sec/employeeworkbalance/multi';
            let params = {
                storeId: this.$store.state.storeId
            };
            let payload = {requests: []}
            Object.values(createMap).forEach(employeeWorkBalance => {
                let request = {
                    employeeId: employeeWorkBalance.employeeId,
                    year: currentMonthFrom.year(),
                    month: currentMonthFrom.month() + 1,
                    workTimeBalance: Math.round(employeeWorkBalance.workTimeBalance*60),
                    vacationTimeBalance: Math.round(employeeWorkBalance.vacationTimeBalance*24*60),
                    holidayTimeBalance: Math.round(employeeWorkBalance.holidayTimeBalance*60),
                    workTimeRegular: Math.round(employeeWorkBalance.workTimeRegular*60),
                    workTime: Math.round(employeeWorkBalance.workTime*60),
                    unproductiveWorkTime: Math.round(employeeWorkBalance.unproductiveWorkTime*60),
                    educationTime: Math.round(employeeWorkBalance.educationTime*60),
                    vacationTime: Math.round(employeeWorkBalance.vacationTime*24*60),
                    paidVacationTime: Math.round(employeeWorkBalance.paidVacationTime*24*60),
                    nursingVacationTime: Math.round(employeeWorkBalance.nursingVacationTime*24*60),
                    holidayTime: Math.round(employeeWorkBalance.holidayTime*60),
                    holidayAdjustmentTime: Math.round(employeeWorkBalance.holidayAdjustmentTime*60),
                    sickTime: Math.round(employeeWorkBalance.sickTime*60),
                    wageContinuationTime: Math.round(employeeWorkBalance.wageContinuationTime*60),
                    miscTime: Math.round(employeeWorkBalance.miscTime*60),
                    miscWorkTime: Math.round(employeeWorkBalance.miscWorkTime*60),
                    paidWorkTime: Math.round(employeeWorkBalance.paidWorkTime*60),
                    paidHolidayTime: Math.round(employeeWorkBalance.paidHolidayTime*60),

                    prevMonthTime: Math.round(employeeWorkBalance.prevMonthTime*60),
                    multiplier: employeeWorkBalance.multiplier,
                    accountingPeriodBalance: Math.round(employeeWorkBalance.accountingPeriodBalance*60),

                    vacationWorkTime: Math.round(employeeWorkBalance.vacationWorkTime*60),
                    nursingVacationWorkTime: Math.round(employeeWorkBalance.nursingVacationWorkTime*60),
                    sickWorkTime: Math.round(employeeWorkBalance.sickWorkTime*60),
                    holidayAdjustmentWorkTime: Math.round(employeeWorkBalance.holidayAdjustmentWorkTime*60),
                    educationWorkTime: Math.round(employeeWorkBalance.educationWorkTime*60),
                    wageContinuationWorkTime: Math.round(employeeWorkBalance.wageContinuationWorkTime*60),

                    prevMonthNightWorkTime: Math.round(employeeWorkBalance.prevMonthNightWorkTime*60),
                    nightWorkTimeBalance: Math.round(employeeWorkBalance.nightWorkTimeBalance*60),
                    paidNightWorkTime: Math.round(employeeWorkBalance.paidNightWorkTime*60),
                    nightWorkTime: Math.round(employeeWorkBalance.nightWorkTime*60),

                    prevMonthOverTime: Math.round(employeeWorkBalance.prevMonthOverTime*60),
                    overTimeBalance: Math.round(employeeWorkBalance.overTimeBalance*60),
                    paidOverTime: Math.round(employeeWorkBalance.paidOverTime*60),
                    overTime: Math.round(employeeWorkBalance.overTime*60),

                    prevMonthMoreTime: Math.round(employeeWorkBalance.prevMonthMoreTime*60),
                    moreTimeBalance: Math.round(employeeWorkBalance.moreTimeBalance*60),
                    paidMoreTime: Math.round(employeeWorkBalance.paidMoreTime*60),
                    moreTime: Math.round(employeeWorkBalance.moreTime*60),

                    dailyOverTime: Math.round(employeeWorkBalance.dailyOverTime*60),
                    weeklyOverTime: Math.round(employeeWorkBalance.weeklyOverTime*60),
                    workDayOverTime: Math.round(employeeWorkBalance.workDayOverTime*60),

                    prevMonthBonusTime: Math.round(employeeWorkBalance.prevMonthBonusTime*60),
                    bonusTimeBalance: Math.round(employeeWorkBalance.bonusTimeBalance*60),
                    paidBonusTime: Math.round(employeeWorkBalance.paidBonusTime*60),
                    bonusTime: Math.round(employeeWorkBalance.bonusTime*60),

                    workTimeMod: Math.round(employeeWorkBalance.workTimeMod*60),
                    moreTimeMod: Math.round(employeeWorkBalance.moreTimeMod*60),
                    overTimeToWorkTime: Math.round(employeeWorkBalance.overTimeToWorkTime*60),
                    holidayTimeToWorkTime: Math.round(employeeWorkBalance.holidayTimeToWorkTime*60),

                    nightWorkCount: employeeWorkBalance.nightWorkCount,
                    overTimeCount: employeeWorkBalance.overTimeCount,
                    moreTimeCount: employeeWorkBalance.moreTimeCount,
                    bonusTimeCount: employeeWorkBalance.bonusTimeCount,

                    holidayCount: employeeWorkBalance.holidayCount,
                    workCount: employeeWorkBalance.workCount,
                    educationCount: employeeWorkBalance.educationCount,
                    vacationCount: employeeWorkBalance.vacationCount,
                    wageContinuationCount: employeeWorkBalance.wageContinuationCount,
                    nursingVacationCount: employeeWorkBalance.nursingVacationCount,
                    miscCount: employeeWorkBalance.miscCount,
                    sickCount: employeeWorkBalance.sickCount,
                    holidayAdjustmentCount: employeeWorkBalance.holidayAdjustmentCount,

                    autoCalc: employeeWorkBalance.autoCalc,
                    autoEqualize: employeeWorkBalance.autoEqualize,
                    appliedAccountingPeriod: employeeWorkBalance.appliedAccountingPeriod,
                    valid: true,
                    confirmed: false,
                    comment: employeeWorkBalance.comment,
                };
                payload.requests.push(request);
            });


            return this.axios({
                method: 'post',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                return new Promise((resolve, reject) => {
                    if(modal){
                        view.$helpers.success(view.$t('global.notifications.updateMessage'), view.$tc('workBalance.payroll.workBalanceUpdated', 2))
                        view.$emit("refresh-workbalances");
                    }
                    resolve(true);
                });

            }).catch(function (error) {
                return new Promise((resolve, reject) => {
                    if(modal){
                        view.$helpers.error(view.$t('global.notifications.updateFailed'), view.$tc('workBalance.payroll.errorWorkBalanceUpdate', 2))
                        console.log(error)
                    }
                    reject(error);
                });

            })
        } else {
            return new Promise((resolve, reject) => {
                resolve(true);
            });

        }


    },

    getMoment: function(str){

        return this.$helpers.getMomentFromStringTZ(str);
    },

    loadEarliestInvalidMonthEmployeeWorkBalanceDate : function(payload) {
        if(this.$helpers.isBlank(payload.ids) || payload.ids.length === 0){
            return new Promise((resolve, reject) => {
                resolve(null);
            })
        } else {
            let view = this;
            let url = '/api/sec/employeeworkbalance/invalid/date/any/employee';


            let params = {
                storeId: this.$store.state.storeId,

            };

            return this.axios({
                method: 'post',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                if(response.data.date != null){
                    return view.$helpers.getMomentFromStringUTC(response.data.date)
                } else {
                    return null;
                }


            }).catch(error => {
                console.log(error)
                return new Promise((accept, reject) =>{
                    accept(null);
                })
            })
        }

    },

    loadCurrentMonthEmployeeWorkBalances : function(payload, monthDate) {
        if(this.$helpers.isBlank(payload.ids) || payload.ids.length === 0){
            return new Promise((resolve, reject) => {
                resolve({});
            })
        } else {
            let view = this;
            let url = '/api/sec/employeeworkbalance/any/employee';
            let from =  monthDate.clone().startOf('month');

            let params = {
                storeId: this.$store.state.storeId,
                from: this.$helpers.getMomentFromValuesUTC(from.year(), from.month(), 1).format(),
                to: this.$helpers.getMomentFromValuesUTC(from.year(), from.month(), 2).format(),
            };

            return this.axios({
                method: 'post',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                let currentEwbMap = {};
                for (let i = 0; i < response.data.length; i++) {
                    currentEwbMap[response.data[i].id] = response.data[i];
                }
                return currentEwbMap;
            })
        }

    },

    loadPreviousMonthEmployeeWorkBalances : function(payload, monthDate) {
        if(this.$helpers.isBlank(payload.ids) || payload.ids.length === 0){
            return new Promise((resolve, reject) => {
                resolve({});
            })
        } else {
            let view = this;
            let url = '/api/sec/employeeworkbalance/any/employee';
            let from = monthDate.clone().subtract(1, 'months').startOf('month');

            let params = {
                storeId: this.$store.state.storeId,
                from: this.$helpers.getMomentFromValuesUTC(from.year(), from.month(), 1).format(),
                to: this.$helpers.getMomentFromValuesUTC(from.year(), from.month(), 2).format(),
            };

            return this.axios({
                method: 'post',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                let previousMonthWorkBalanceMap = {};
                for (let i = 0; i < response.data.length; i++) {
                    previousMonthWorkBalanceMap[response.data[i].employeeId] = response.data[i];
                }
                return previousMonthWorkBalanceMap;
            })
        }

    },
    loadEmployeePlanShifts : function(employeeIdReq, monthDate) {
        let params = null;
        let payload = {
            employeeIds: employeeIdReq,
            spotIds: {ids: []}
        }
        let monthDateTZ = this.$helpers.getMomentFromValuesTZ(monthDate.year(), monthDate.month(), 1);
        params = {
            storeId: this.$store.state.storeId,
            from: monthDateTZ.clone().startOf('week').subtract(1,'days').format(),
            to: monthDateTZ.clone().add(1, 'month').endOf('week').add(1,'days').startOf('day').format(),
        };

        let url = '/api/sec/planshift/any/spot/employee';


        return this.axios({
            method: 'post',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            let employeePlanShiftMap = {};
            for (let i = 0; i < response.data.length; i++) {
                if(response.data[i].employeeId){
                    if(!employeePlanShiftMap[response.data[i].employeeId]){
                        employeePlanShiftMap[response.data[i].employeeId] = [];
                    }
                    employeePlanShiftMap[response.data[i].employeeId].push(response.data[i]);
                }

            }
            return employeePlanShiftMap;
        })

    },
    loadActualShifts : function(payload, monthDate) {

        let monthDateTZ = this.$helpers.getMomentFromValuesTZ(monthDate.year(), monthDate.month(), 1);
        let params = {
            from: monthDateTZ.clone().startOf('week').subtract(1,'days').format(),
            to: monthDateTZ.clone().add(1, 'month').endOf('week').add(1,'days').startOf('day').format(),
        };

        let url = '/api/sec/actualshift';


        return this.$helpers.RecursiveGETPaged(url, [], params, 1, 3)
        .then(response => {
            let actualShiftMap = {};
            for (let i = 0; i < response.length; i++) {
                actualShiftMap[response[i].id] = response[i];
            }
            return actualShiftMap;
        })

    },
    loadBonusPaymentSettings : function(monthDate) {

        let monthDateTZ = this.$helpers.getMomentFromValuesTZ(monthDate.year(), monthDate.month(), 1);
        let params = {
            from: monthDateTZ.clone().startOf('week').subtract(1,'days').format(),
            to: monthDateTZ.clone().add(1, 'month').endOf('week').add(1,'days').startOf('day').format(),
        };

        let url = '/api/sec/bonuspaymentsetting';


        return this.$helpers.RecursiveGETPaged(url, [], params, 1, 3)
        .then(response => {
            let map = {};
            for (let i = 0; i < response.length; i++) {
                map[response[i].id] = response[i];
            }
            return map;
        })

    },
    loadActualBreaks : function(payload, monthDate) {
        let params = null;
        let monthDateTZ = this.$helpers.getMomentFromValuesTZ(monthDate.year(), monthDate.month(), 1);
        params = {
            from: monthDateTZ.clone().startOf('week').subtract(1,'days').format(),
            to: monthDateTZ.clone().add(1, 'month').endOf('week').add(1,'days').startOf('day').format(),
        };
        let url = '/api/sec/actualbreak';


        return this.$helpers.RecursiveGETPaged(url, [], params, 1, 3)
        .then(response => {
            let actualBreakMap = {};
            for (let i = 0; i < response.length; i++) {
                actualBreakMap[response[i].id] = response[i];
            }
            return actualBreakMap;
        })

    },
    loadEmployeePreferences : function(payload, monthDate) {
        if(this.$helpers.isBlank(payload.ids) || payload.ids.length === 0){
            return new Promise((resolve, reject) => {
                resolve({});
            })
        } else {
            let params = null;
            let monthDateTZ = this.$helpers.getMomentFromValuesTZ(monthDate.year(), monthDate.month(), 1);
            params = {
                storeId: this.$store.state.storeId,
                from: monthDateTZ.clone().startOf('week').subtract(1,'days').format(),
                to: monthDateTZ.clone().add(1, 'month').endOf('week').add(1,'days').startOf('day').format(),
                approved: true
            };
            let url = '/api/sec/employeepreference/any/employee';



            return this.axios({
                method: 'post',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                let employeePreferenceMap = {};
                for (let i = 0; i < response.data.length; i++) {
                    if(response.data[i].employeeId){
                        if(!employeePreferenceMap[response.data[i].employeeId]){
                            employeePreferenceMap[response.data[i].employeeId] = [];
                        }
                        employeePreferenceMap[response.data[i].employeeId].push(response.data[i]);
                    }
                }
                return employeePreferenceMap;
            })
        }
    },
    loadEmployeeContracts : function(payload, monthDate) {
        if(this.$helpers.isBlank(payload.ids) || payload.ids.length === 0){
            return new Promise((resolve, reject) => {
                resolve({});
            })
        } else {
            let params = null;
            let monthDateTZ = this.$helpers.getMomentFromValuesTZ(monthDate.year(), monthDate.month(), 1);
            params = {
                storeId: this.$store.state.storeId,
                from: monthDateTZ.clone().startOf('week').subtract(1,'days').format(),
                to: monthDateTZ.clone().add(1, 'month').endOf('week').add(1,'days').startOf('day').format(),
                overlapping: true,
            };
            let url = '/api/sec/employeecontract/any/employee';

            return this.axios({
                method: 'post',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                let employeeContractMap = {};
                for (let i = 0; i < response.data.length; i++) {
                    if(response.data[i].employeeId){
                        if(!employeeContractMap[response.data[i].employeeId]){
                            employeeContractMap[response.data[i].employeeId] = [];
                        }
                        employeeContractMap[response.data[i].employeeId].push(response.data[i]);
                    }
                }
                return employeeContractMap;
            });
        }

    },
    loadNextMonthEmployeeContracts : function(payload, monthDate) {
        if(this.$helpers.isBlank(payload.ids) || payload.ids.length === 0){
            return new Promise((resolve, reject) => {
                resolve({});
            })
        } else {
            let view = this;
            let monthDateTZ = this.$helpers.getMomentFromValuesTZ(monthDate.year(), monthDate.month(), 1);
            let params = {
                storeId: this.$store.state.storeId,
                from: monthDateTZ.clone().add(1, 'month').format(),
                to: monthDateTZ.clone().add(2, 'month').format(),
                overlapping: true,
            };
            let url = '/api/sec/employeecontract/any/employee';



            return this.axios({
                method: 'post',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                let data = response.data;
                let employeeContractMap = {};
                for (let i = 0; i < data.length; i++) {
                    if(employeeContractMap[data[i].employeeId]){
                        let prevStart = view.$helpers.getMomentFromStringTZ(employeeContractMap[data[i].employeeId].from);
                        let start = view.$helpers.getMomentFromStringTZ(data[i].from);
                        if(start < prevStart){
                            employeeContractMap[data[i].employeeId] = data[i];
                        }
                    } else {
                        employeeContractMap[data[i].employeeId] = data[i];
                    }

                }
                return employeeContractMap;
            });
        }

    },

    loadHolidays: function(monthDate) {
        let params = null;
        let monthDateTZ = this.$helpers.getMomentFromValuesTZ(monthDate.year(), monthDate.month(), 1);
        params = {
            storeId: this.$store.state.storeId,
            from: monthDateTZ.format(),
            to: monthDateTZ.clone().add(1, 'month').format(),
            active: true,
        };
        let url = '/api/sec/storeevent';

        return this.axios({
            method: 'get',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        }).then(response => {
            let holidayMap = {};
            for (let i = 0; i < response.data.length; i++) {
                let holiday = response.data[i];
                if(holiday.federalHoliday || holiday.bankHoliday || holiday.contractHoliday){
                    holiday.fromMoment = this.$helpers.getMomentFromStringTZ(holiday.from);
                    holiday.toMoment = this.$helpers.getMomentFromStringTZ(holiday.to);
                    holidayMap[holiday.id] = holiday;
                }
                
            }
            return holidayMap;
        })
    },
    loadValidEmployeeWorkBalanceEmployees: function(monthDate) {
        let params = null;
        params = {
            storeId: this.$store.state.storeId,
            date: monthDate.format(),
        };
        let url = '/api/sec/employeeworkbalance/valid/employee';


        return this.axios({
            method: 'get',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        }).then(response => {
            let validEmployeeMap = {};
            for (let i = 0; i < response.data.length; i++) {
                validEmployeeMap[response.data[i].employeeId] = true;

            }
            return validEmployeeMap;
        })
    },
    loadActiveAtEmployees: function (monthDate) {
        let url = '/api/sec/employee';
        let params = null;
        let monthDateFrom = monthDate.clone().add(-1, 'month');
        //let monthDateFromTZ = this.$helpers.getMomentFromValuesTZ(monthDateFrom.year(), monthDateFrom.month(), 1);
        let monthDateTo = monthDate.clone().add(2, 'month');
        //let monthDateToTZ = this.$helpers.getMomentFromValuesTZ(monthDateTo.year(), monthDateTo.month(), 1);
        params = {
            storeId: this.$store.state.storeId,
            activeAtFrom: monthDateFrom.format(),
            activeAtTo: monthDateTo.format(),
            ewbDate: this.$helpers.getMomentFromValuesUTC(monthDate.year(), monthDate.month(), 1).format(),
            bridgeFutureContract: true //this optional flag is only necessary here to load employees which have contracts in the future, in case an ewb can be created for the current month because the employee worked in the store before
        };



        return this.axios({
            method: 'get',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer " + this.$store.state.jwt
            },
            url: url
        }).then(response => {
            let employeeMap = {};
            for (let i = 0; i < response.data.length; i++) {
                employeeMap[response.data[i].id] = response.data[i];
            }
            return employeeMap;
        })

    },

  },


}
</script>

<style scoped>

</style>
